import styled from "styled-components";

const LoginCard = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px auto 24px;

  width: 400px;
  padding: 32px 40px;
  background: rgb(255, 255, 255);
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  box-sizing: border-box;
  color: rgb(94, 108, 132);

  h1 {
    text-align: center;
    color: black;
    font-size: 28px;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 10px;
  }

  h3 {
    text-align: center;
    color: #415069;
    font-size: 16px;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 25px;
  }

  button {
    margin-top: 20px;
    font-weight: 500;
    text-transform: capitalize;
    background-color: #3baf91;

    &:hover {
      background-color: #2da385;
    }
  }

  input {
    border-color: rgb(223, 225, 230);
    border-radius: 3px;
    border-style: solid;
    outline: #3baf91;
  }

  img {
    margin: auto;
    padding-left: 30px;
  }
`;

export { LoginCard };
